
Vue.config.productionTip = false

// Vant 组件库按需引入
import Vue from 'vue'
import { Overlay, Popup, Dialog, Area, Toast, SwipeCell, Picker, Switch, Collapse, CollapseItem, Swipe, SwipeItem, PullRefresh } from 'vant'
import 'vant/lib/overlay/style'
import 'vant/lib/popup/style'
import 'vant/lib/dialog/style'
import 'vant/lib/area/style'
import 'vant/lib/toast/style'
import 'vant/lib/swipe-cell/style'
import 'vant/lib/picker/style'
import 'vant/lib/switch/style'
import 'vant/lib/collapse/style'
import 'vant/lib/collapse-item/style'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'

Vue.use(Overlay)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Area)
// Toast.setDefaultOptions({position: 'bottom'});
Vue.use(Toast)
Vue.use(SwipeCell)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Collapse).use(CollapseItem)
Vue.use(Swipe).use(SwipeItem)
Vue.use(PullRefresh)

// 引入ECharts主模块 :: 引入柱状图
window.echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/line');
require('echarts/lib/chart/radar');

// 二维码组件导入
import VueQrcode from '@xkeshi/vue-qrcode'
Vue.component(VueQrcode.name, VueQrcode);

// import _ from 'lodash'
// Object.defineProperty(Vue.prototype, '$_', { value: _ });
// var vConsole = process.env.NODE_ENV == 'production' ? new VConsole() : null;

const Bus = new Vue({
    methods: {
        emit (event, ...args) {
            this.$emit(event, ...args)
        },
        on (event, callback) {
            this.$on(event, callback)
        },
        off (event, callback) {
            this.$off(event, callback)
        }
    }
})
Vue.prototype.$bus = Bus

// 样式库引入
// basic part
import './assets/style/base.css'    
import './assets/style/common.css'
import './assets/style/iconfont/iconfont.css'

import './assets/style/pages/pg-index.css'
import './assets/style/pages/pg-generate.css'
import './assets/style/pages/pg-report.css'

import login from './modules/login'
login.checkLogin();